import { heroData } from "../../../mocks/columnData";

export default function ColumnHero() {
  return (
    <section className="relative h-[300px] md:h-[400px] overflow-hidden">
      <img
        src={heroData.image}
        alt="AIRDOAコラム"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-airdoa-navy/50 via-airdoa-navy/30 to-airdoa-navy/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <p className="text-xs md:text-sm tracking-ultra text-airdoa-gold mb-3 md:mb-4">
          COLUMN
        </p>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight">
          {heroData.title}
        </h1>
        <p className="mt-4 max-w-2xl text-sm md:text-base text-white/80 leading-relaxed">
          {heroData.subtitle}
        </p>
      </div>
    </section>
  );
}
